import { cn } from "@/lib/utils";
import type { HTMLAttributes, ReactNode } from "react";

type PanelHeaderProps = HTMLAttributes<HTMLDivElement> & {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
};

export function PanelHeader({
  title,
  description,
  actions,
  className,
  ...props
}: PanelHeaderProps) {
  return (
    <div className={cn("app-panel-header", className)} {...props}>
      <div className="min-w-0">
        <p className="app-section-eyebrow truncate">{title}</p>
        {description ? (
          <p className="app-section-description mt-1 truncate">{description}</p>
        ) : null}
      </div>
      {actions}
    </div>
  );
}
